import React, { useCallback } from 'react';
import { AttachmentViewerModal, FeedsAllFeeds } from '@orijinworks/frontend-commons';
import { useAttachmentPreviewHook } from '../../hooks/attachments/useAttachmentPreviewHook';
import { ADMIN_ATTACHMENT_RENDER_CONTENT_BY_FILE_TYPE } from '../../mappers/adminAttachmentChipDisplay';
import { fetchFeedAttachmentPreview } from '../../utils/feedAttachmentFetchPreview';

/**
 * All Feeds tab: attachment preview modal with admin PdfViewer for PDFs.
 */
const AllFeedsWithAttachmentPreview = (allFeedsProps) => {
  const fetchPreview = useCallback(
    (attachment) => fetchFeedAttachmentPreview(attachment),
    [],
  );
  const {
    previewForModal,
    loadingAttachmentId,
    onAttachmentPreviewRequest,
    onCloseAttachmentPreview,
  } = useAttachmentPreviewHook({ fetchPreview });

  return (
    <>
      <FeedsAllFeeds
        {...allFeedsProps}
        onAttachmentPreviewRequest={onAttachmentPreviewRequest}
        loadingAttachmentId={loadingAttachmentId}
      />
      {previewForModal && (
        <AttachmentViewerModal
          fileUrl={previewForModal.url}
          fileName={previewForModal.fileName}
          fileType={previewForModal.fileType}
          open={true}
          onClose={onCloseAttachmentPreview}
          renderContentByFileType={ADMIN_ATTACHMENT_RENDER_CONTENT_BY_FILE_TYPE}
        />
      )}
    </>
  );
};

export default AllFeedsWithAttachmentPreview;
